import React, { Component } from 'react';
import JobCard from './JobCard';
import JobDetailsModal from './JobDetailsModal';
import JobsData from './JobsData';

class JobsSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedJob: null,
            isModalOpen: false
        };
    }

    handleViewDetails = (job) => {
        this.setState({ selectedJob: job, isModalOpen: true });
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }

    handleCloseModal = () => {
        this.setState({ selectedJob: null, isModalOpen: false });
        document.body.style.overflow = 'auto'; // Restore scrolling
    }

    render() {
        return (
            <div>
                {/*====================  jobs section area ====================*/}
                <div className={`jobs-section-area section-space--inner--120 ${this.props.background || ''}`}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* section title */}
                                <div className="section-title-area text-center">
                                    <h2 className="section-title section-space--bottom--50">We Are Hiring</h2>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="jobs-grid-wrapper">
                                    <div className="row">
                                        {JobsData.map((job) => (
                                            <JobCard
                                                key={job.id}
                                                job={job}
                                                onViewDetails={this.handleViewDetails}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.isModalOpen && (
                    <JobDetailsModal
                        job={this.state.selectedJob}
                        onClose={this.handleCloseModal}
                    />
                )}
                {/*====================  End of jobs section area  ====================*/}
            </div>
        );
    }
}

export default JobsSection;
